import { format, parseISO, isValid } from 'date-fns';

/**
 * Formats a reservation name. If the name is an ISO timestamp string,
 * formats it as a readable date/time string. Otherwise, returns the name as-is.
 *
 * @param {string} name - The reservation name or ISO timestamp string
 * @returns {string} Formatted date string or original name
 */
export const formatReservationName = name => {
  if (!name) return '';
  const date = parseISO(name);
  if (!isValid(date)) return name;
  return format(date, "MMMM d, yyyy 'at' h:mm a");
};
